const basicDetailsSchema = Object.seal({
    feilds: [{
        id: 1,
        name: 'counselling_date',
        title: 'Date of Counselling *',
        visible: true,
        element: 'datepicker',
        required: false,
        type: 'text',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter Date of Counselling'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 1,
        name: 'token_number',
        title: 'Token Number *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter Token Number'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 12,
        name: 'counselling_type',
        title: 'Counselling Type *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            // test: (value) => {
            //     return (value !== null && value.length > 0 && value != '');
            // },
            // message: 'Please Enter Counselling Type'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 13,
        name: 'ip_number',
        title: 'IP Number',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 7,
        name: 'umr_number',
        title: 'UMR Number *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter UMR Number'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 2,
        name: 'patient_name',
        title: 'Patient name *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 3,
        name: 'age',
        title: 'Age *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 4,
        name: 'gender',
        title: 'Gender *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 8,
        name: 'phone_number',
        title: 'Phone Number *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 14,
        name: 'marital_status',
        title: 'Marital Status',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    },
    {
        id: 9,
        name: 'doctor_name',
        title: 'Doctor Name *',
        visible: true,
        element: 'select',
        required: true,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value !== 0 && value !== '' && value !== undefined);
            },
            message: 'Please Select Doctor'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 10,
        name: 'speciality',
        title: 'Speciality *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 15,
        name: 'address',
        title: 'Address',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-9 mt-3'
    }, {
        id: 16,
        name: 'payment_mode',
        title: 'Mode of Payment *',
        visible: true,
        element: 'select',
        required: true,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value !== 0 && value != '' && value != undefined);
            },
            message: 'Please Select Mode of Payment'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 17,
        name: 'service_type',
        title: 'Service Type *',
        visible: false,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter Service Type'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 18,
        name: 'payment_change_reason',
        title: 'Payment Change Reason',
        visible: false,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-12 mt-3'
    }]
})

const medicationDetailsSchema = Object.seal({
    feilds: [{
        id: 5,
        name: 'estimated_admission_date',
        title: 'Estimated Date of Admission *',
        visible: true,
        element: 'datepicker',
        required: false,
        type: 'datepicker',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value !== '');
            },
            message: 'Select Estimated Date Of Admission'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3',
        message: 'Please select estimated date of admission'
    }, {
        id: 6,
        name: 'actual_admission_date',
        title: 'Actual Date of Admission',
        visible: false,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    },
     {
        id: 11,
        name: 'diagnosis',
        title: 'Diagnosis',
        visible: false,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3',
        message: 'Please enter diagnosis'
    }, 
    {
        id: 16,
        name: 'care_management',
        title: 'Care Management *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Select Care Management'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3',
        message: 'Please select care management'
    }, {
        id: 17,
        name: 'estimate_type',
        title: 'Estimate Type *',
        visible: false,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Select Estimate Type'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3',
        message: 'Please select estimate type'
    },
    {
        id: 32,
        name: 'date_of_surgery',
        title: 'Date of Surgery *',
        visible: true,
        element: 'datepicker',
        required: false,
        type: 'datepicker',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0 && value != '');
                },
                message: 'Please Enter Date'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3',
        message: 'Please select surgery date'
    }, {
        id: 33,
        name: 'surgery_procedure_name',
        title: 'Surgery/Procedure name *',
        header: 11,
        sub_header: 20,
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0 && value != '');
                },
                message: 'Please Select Name'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 34,
        name: 'surgery_procedure_amount',
        title: 'Surgery/Procedure Amount *',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: '--',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    },
     {
        id: 18,
        name: 'package_name',
        title: 'Package Name *',
        visible: false,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Select Package Name'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3',
        message: 'Please select package name'
    }, {
        id: 19,
        name: 'length_of_stay',
        title: 'Length of Stay (Days)*',
        visible: true,
        element: 'input',
        required: true,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0 && value != '');
                },
                message: 'Please Enter Length of Stay'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3',
        message: 'Please enter length of stay'
    }, {
        id: 20,
        name: 'icu_stay',
        title: 'ICU Stay (Days)',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 21,
        name: 'room_stay',
        title: 'Room Stay (Days)',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 28,
        name: 'room_opted',
        title: 'Room Opted *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0 && value != '');
                },
                message: 'Please Select Room Opted'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3',
        message: 'Please select room opted'
    }, {
        id: 29,
        name: 'room_upgrade',
        title: 'Room Upgrade',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 30,
        name: 'room_upgrade_reason',
        title: 'Room Upgrade Reason *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0 && value != '');
                },
                message: 'Please Select Room Upgrade Reason'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 31,
        name: 'icu_opted',
        title: 'ICU Type*',
        visible: false,
        element: 'select',
        required: true,
        type: 'select',
        placeholder: 'Select ICU',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0 && value != '');
                },
                message: 'Please Select ICU Type '
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    },]
})

const additionalPackageSchema = {
    feilds: [{
        id: 1,
        name: 'additional_package',
        title: 'Additional package',
        visible: false,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Additional package',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Package Name', width: "40%" }, { 'id': 4, 'text': 'Package Amount (Rs.)', width: "30%" }, { 'id': 6, 'text': 'Action', width: "5%" }],
            'table_body': [],
            'add_more_feilds': [{
                id: 1,
                name: 'additional_package_name',
                title: 'package Name',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'number',
                placeholder: 'Select',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'routine',
                table: 'additional_package',
            }, {
                id: 1,
                name: 'amount',
                title: 'Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'routine',
                table: 'additional_package',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'routine',
                table: 'additional_package',
            }],
        }
    },]
}

const additionalProcedureSchema = {
    feilds: [{
        id: 1,
        name: 'additional_procedure',
        title: 'Additional Procedure',
        visible: false,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Additional Procedure',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Procedure Name', width: "20%" }, { 'id': 4, 'text': 'Amount (Rs.)', width: "25%" }, { 'id': 6, 'text': 'Action', width: "5%" }],
            'table_body': [],
            'add_more_feilds': [{
                id: 1,
                name: 'additional_surgery_procedure_name',
                service: 11,
                header: 11,
                sub_header: 20,
                title: 'Procedure Name',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'number',
                placeholder: 'Select',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'routine',
                table: 'additional_procedure',
            }, {
                id: 1,
                name: 'amount',
                title: 'Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'routine',
                table: 'additional_procedure',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'routine',
                table: 'additional_procedure',
            }],
        }
    },]
}

const estimateBreakupFormatSchema = Object.seal({
    feilds: [{
        id: 1,
        name: 'base_price',
        title: 'Base Price',
        visible: false,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 2,
        name: 'excludes',
        title: 'Excludes',
        visible: false,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 3,
        name: 'total_Estimate_amount',
        title: 'Total Estimate amount',
        visible: false,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 5,
        name: 'name_of_the_fc',
        title: 'Name of the FC',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 7,
        name: 'attendant_name',
        title: 'Attendant name *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value !== '');
            },
            message: 'Enter the Attendant name'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 8,
        name: 'relation',
        title: 'Relation *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value !== '');
            },
            message: 'Enter the Relation'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    },{
        id: 9,
        name: 'remarks',
        title: 'Remarks *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value !== '');
            },
            message: 'Enter the Remarks'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'}]
})

const addonSchema = {
    feilds: [
        {
        id: 1,
        name: 'room_charges',
        header: 1,
        header_amount: 0,
        title: 'Room charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'room',
                'feilds': [{
                    id: 1,
                    service: 1,
                    sub_header: 1,
                    name: 'room',
                    title: 'Room',
                    visible: true,
                    element: 'text',
                    row_group: 'room',
                    table: 'room_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Room Charges Qty.',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Room Charges Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'room',
                    table: 'room_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Room Charges Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Room Charges Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'room',
                    table: 'room_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Room Charges Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Room Charges Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'room',
                    table: 'room_charges',
                }]
            }, {
                'id': 2,
                'key_word': 'icu',
                'feilds': [{
                    id: 1,
                    service: 2,
                    sub_header: 2,
                    name: 'icu',
                    title: 'ICU',
                    visible: true,
                    element: 'text',
                    row_group: 'icu',
                    table: 'room_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'ICU Charges Qty.',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'ICU Charges Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'icu',
                    table: 'room_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'ICU Charges Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'ICU Charges Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'icu',
                    table: 'room_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'ICU Charges Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'ICU Charges Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'icu',
                    table: 'room_charges',
                }]
            }
            ],
            'add_more_feilds': [],
        }
    }, {
        id: 2,
        name: 'room_investigation_charges',
        header: 2,
        header_amount: 0,
        title: 'Room Investigation Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Highend Room Investigation',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'text': 'Routine',
                'key_word': 'routine',
                'type': 'text',
                'input_feild': [],
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 2,
                    sub_header: 5,
                    name: 'Routine',
                    title: 'Routine',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    tooltip:null,
                    table: 'room_investigation_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Room Investigation Quantity',
                    rules: [],
                    errors: [],
                    value: 0,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'w-100',
                    row_group: 'routine',
                    table: 'room_investigation_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Room Investigation Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Room Investigation Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'room_investigation_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Room Investigation Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Room Investigation Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'room_investigation_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'room_investigation_charges',
                },]
            },
            {
                'id': 2,
                'text': 'Highend',
                'type': 'text',
                'key_word': 'highend',
                'input_feild': [],
                'feilds': [{
                    id: 2,
                    service: null,
                    header: 2,
                    sub_header: 6,
                    name: 'room_highend_investigations',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Highend Room Investigation',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-12 p-0',
                    row_group: 'highend',
                    table: 'room_investigation_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Room Investigation Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'w-100',
                    row_group: 'highend',
                    table: 'room_investigation_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Highend Room Investigation Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Room Investigation Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'room_investigation_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Highend Room Investigation Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Room Investigation Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'room_investigation_charges',
                }, {
                    id: 2,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'highend',
                    table: 'room_investigation_charges',
                },]
            }],
            'add_more_feilds': [{
                id: 1,
                service: null,
                header: 2,
                sub_header: 6,
                name: 'room_highend_investigations',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Highend Room Investigation',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'highend',
                table: 'room_investigation_charges',
            }, {
                id: 1,
                name: 'qty',
                title: 'Highend Room Investigation Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Room Investigation Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'highend',
                table: 'room_investigation_charges',
            }, {
                id: 1,
                name: 'rate',
                title: 'Highend Room Investigation Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Room Investigation Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'room_investigation_charges',
            }, {
                id: 1,
                name: 'amount',
                title: 'Highend Room Investigation Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Room Investigation Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'room_investigation_charges',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'highend',
                table: 'room_investigation_charges',
            }],
        }
    }, {
        id: 3,
        name: 'icu_investigation_charges',
        header: 3,
        header_amount: 0,
        title: 'ICU Investigation Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Highend ICU Investigation',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'text': 'Routine',
                'type': 'text',
                'key_word': 'routine',
                'input_feild': [],
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 3,
                    sub_header: 7,
                    name: 'Routine',
                    title: 'Routine',
                    visible: true,
                    element: 'text',
                    tooltip:null,
                    row_group: 'routine',
                    table: 'icu_investigation_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine ICU Investigation Quantity',
                    rules: [],
                    errors: [],
                    value: 0,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'w-100',
                    row_group: 'routine',
                    table: 'icu_investigation_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine ICU Investigation Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine ICU Investigation Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'icu_investigation_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine ICU Investigation Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine ICU Investigation Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'icu_investigation_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'icu_investigation_charges',
                },]
            },
            {
                'id': 2,
                'text': 'Highend',
                'type': 'text',
                'key_word': 'highend',
                'input_feild': [],
                'feilds': [{
                    id: 2,
                    service: null,
                    header: 3,
                    sub_header: 8,
                    name: 'icu_highend_investigations',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Highend ICU Investigation',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-12 p-0',
                    row_group: 'highend',
                    table: 'icu_investigation_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend ICU Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'w-100',
                    row_group: 'highend',
                    table: 'icu_investigation_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Highend ICU Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend ICU Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'icu_investigation_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Highend ICU Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend ICU Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'icu_investigation_charges',
                }, {
                    id: 2,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'highend',
                    table: 'icu_investigation_charges',
                },]
            }],
            'add_more_feilds': [{
                id: 1,
                service: null,
                header: 3,
                sub_header: 8,
                name: 'icu_highend_investigations',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Highend ICU Investigation',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'highend',
                table: 'icu_investigation_charges',
            }, {
                id: 1,
                name: 'qty',
                title: 'Highend ICU Investigation Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend ICU Investigation Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'highend',
                table: 'icu_investigation_charges',
            }, {
                id: 1,
                name: 'rate',
                title: 'Highend ICU Investigation Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend ICU Investigation Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'icu_investigation_charges',
            }, {
                id: 1,
                name: 'amount',
                title: 'Highend ICU Investigation Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend ICU Investigation Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'icu_investigation_charges',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'highend',
                table: 'icu_investigation_charges',
            }],
        }
    }, {
        id: 4,
        name: 'ip_pharmacy_charges',
        header: 4,
        header_amount: 0,
        title: 'IP Pharmacy charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Highend Drugs',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'routine',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 4,
                    sub_header: 9,
                    name: 'routine_drugs_implants',
                    title: 'Routine Drugs ',
                    visible: true,
                    element: 'text',
                    tooltip:null,
                    row_group: 'routine',
                    table: 'ip_pharmacy_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Routine Drugs Quantity ',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs Quantity',
                    rules: [],
                    errors: [],
                    value: 0,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ip_pharmacy_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Drugs Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ip_pharmacy_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Drugs Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ip_pharmacy_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'ip_pharmacy_charges',
                }]
            }, {
                'id': 2,
                'key_word': 'highend',
                'feilds': [{
                    id: 2,
                    service: null,
                    header: 4,
                    sub_header: 10,
                    name: 'room_highend_drugs_implants',
                    title: 'Highend Drugs',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Highend Drugs ',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ip_pharmacy_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Highend Drugs  Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ip_pharmacy_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Highend Drugs Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs  Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ip_pharmacy_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Highend Drugs Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ip_pharmacy_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'highend',
                    table: 'ip_pharmacy_charges',
                }]
            }],
            'add_more_feilds': [{
                id: 1,
                service: null,
                header: 4,
                sub_header: 10,
                name: 'room_highend_drugs_implants',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Highend Drugs',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'highend',
                table: 'ip_pharmacy_charges',
            }, {
                id: 1,
                name: 'qty',
                title: 'Highend Drugs Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Drugs Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'highend',
                table: 'ip_pharmacy_charges',
            }, {
                id: 1,
                name: 'rate',
                title: 'Highend Drugs Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Drugs Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ip_pharmacy_charges',
            }, {
                id: 1,
                name: 'amount',
                title: 'Highend Drugs  Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Drugs Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ip_pharmacy_charges',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'highend',
                table: 'ip_pharmacy_charges',
            }]
        }
    }, {
        id: 5,
        name: 'icu_pharmacy_charges',
        header: 5,
        header_amount: 0,
        title: 'ICU Pharmacy charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Highend Drugs',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'routine',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 5,
                    sub_header: 11,
                    name: 'routine_drugs_implants',
                    title: 'Routine Drugs',
                    visible: true,
                    element: 'text',
                    tooltip:null,
                    row_group: 'routine',
                    table: 'icu_pharmacy_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Routine Drugs Quantity ',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs Quantity ',
                    rules: [],
                    errors: [],
                    value: 0,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'icu_pharmacy_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Drugs  Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs  Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'icu_pharmacy_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Drugs  Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs  Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'icu_pharmacy_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'icu_pharmacy_charges',
                }]
            }, {
                'id': 2,
                'key_word': 'highend',
                'feilds': [{
                    id: 2,
                    service: null,
                    header: 5,
                    sub_header: 12,
                    name: 'icu_highend_drugs_implants',
                    title: 'Highend Drugs ',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Highend Drugs ',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'icu_pharmacy_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Highend Drugs Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'icu_pharmacy_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Highend Drugs Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'icu_pharmacy_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Highend Drugs Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'icu_pharmacy_charges',
                }, , {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'highend',
                    table: 'icu_pharmacy_charges',
                },]
            }],
            'add_more_feilds': [{
                id: 1,
                service: null,
                header: 5,
                sub_header: 12,
                name: 'icu_highend_drugs_implants',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Highend Drugs ',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'highend',
                table: 'icu_pharmacy_charges',
            }, {
                id: 1,
                name: 'qty',
                title: 'Highend Drugs Quantity.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Drugs  Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'highend',
                table: 'icu_pharmacy_charges',
            }, {
                id: 1,
                name: 'rate',
                title: 'Highend Drugs  Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Drugs  Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'icu_pharmacy_charges',
            }, {
                id: 1,
                name: 'amount',
                title: 'Highend Drugs  Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Drugs  Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'icu_pharmacy_charges',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'highend',
                table: 'icu_pharmacy_charges',
            }]
        }
    }, {
        id: 6,
        name: 'ot_cath_pharmacy',
        header: 6,
        header_amount: 0,
        title: 'OT/Cath Pharmacy',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Highend Drugs',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'routine',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 6,
                    sub_header: 13,
                    name: 'routine',
                    title: 'Routine Drugs',
                    visible: true,
                    element: 'text',
                    tooltip:null,
                    row_group: 'routine',
                    table: 'ot_cath_pharmacy',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Routine',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ot_cath_pharmacy',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ot_cath_pharmacy',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ot_cath_pharmacy',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'ot_cath_pharmacy',
                },]
            }, {
                'id': 2,
                'key_word': 'highend',
                'feilds': [{
                    id: 2,
                    service: null,
                    header: 6,
                    sub_header: 14,
                    name: 'ot_cath_highend_drugs_implants',
                    title: 'Highend Drugs ',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Highend Drugs ',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ot_cath_pharmacy',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Highend Drugs  Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs  Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ot_cath_pharmacy',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Highend Drugs  Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs  Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ot_cath_pharmacy',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Highend Drugs  Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs  Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ot_cath_pharmacy',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'highend',
                    table: 'ot_cath_pharmacy',
                },]
            }],
            'add_more_feilds': [{
                id: 1,
                service: null,
                header: 6,
                sub_header: 14,
                name: 'ot_cath_highend_drugs_implants',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Highend Drugs ',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'highend',
                table: 'ot_cath_pharmacy',
            }, {
                id: 1,
                name: 'qty',
                title: 'Highend Drugs  Quantity.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Drugs  Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_cath_pharmacy',
            }, {
                id: 1,
                name: 'rate',
                title: 'Highend Drugs  Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Drugs  Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_cath_pharmacy',
            }, {
                id: 1,
                name: 'amount',
                title: 'Highend Drugs  Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Drugs  Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_cath_pharmacy',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'highend',
                table: 'ot_cath_pharmacy',
            }],
        }
    }, {
        id: 7,
        name: 'drug_admin_charges',
        header: 7,
        header_amount: 0,
        title: 'Drug Admin Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'routine',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 7,
                    sub_header: 15,
                    name: 'routine',
                    title: 'Drug Admin Charges',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'drug_admin_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    header: 7,
                    sub_header: 15,
                    title: 'Routine Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'drug_admin_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'drug_admin_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'drug_admin_charges',
                }]
            }]
        }
    }, {
        id: 8,
        name: 'general_equipment_charges',
        header: 8,
        header_amount: 0,
        title: 'General Equipment Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title':'Add General Equipment Charges',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" },{ 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'routine',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 8,
                    sub_header: 35,
                    name: 'routine',
                    title: 'Routine',
                    visible: true,
                    element: 'text',
                    tooltip:null,
                    row_group: 'routine',
                    table: 'general_equipment_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Routine Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'general_equipment_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'general_equipment_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'general_equipment_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'general_equipment_charges',
                },]
            },
                {
                'id': 2,
                'key_word': 'highend',
                'feilds': [{
                    id: 2,
                    service: 1,
                    header: 8,
                    sub_header: 16,
                    name: 'general_highend_equipments',
                    title: 'Equipment Charges',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Equipment Type',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'general_equipment_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Equipment Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Equipment Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'general_equipment_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Equipment Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Equipment Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'general_equipment_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Equipment Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Equipment Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'general_equipment_charges',
                },{
                    id: 2, 
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'highend',
                    table: 'general_equipment_charges',
                }]
            }],
            'add_more_feilds': [{
                id: 2,
                service: null,
                header: 8,
                sub_header: 16,
                name: 'general_highend_equipments',
                title: 'Equipment Charges',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Equipment Type',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'highend',
                table: 'general_equipment_charges',
            }, {
                id: 2,
                name: 'qty',
                title: 'Equipment Quantity',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Equipment Quantity',
                rules: [],
                errors: [],
                value: 0,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'highend',
                table: 'general_equipment_charges',
            }, {
                id: 2,
                name: 'rate',
                title: 'Equipment Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Equipment Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'highend',
                table: 'general_equipment_charges',
            }, {
                id: 2,
                name: 'amount',
                title: 'Equipment Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Equipment Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'general_equipment_charges',
            },{
                id: 2,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'highend',
                table: 'general_equipment_charges',
            }
            ],
        }
    }, {
        id: 9,
        name: 'ot_charges',
        header: 9,
        header_amount: 0,
        title: 'OT Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add OT Charges',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [
            {
                'id': 1,
                'key_word': 'ot_inst_disinfec',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 9,
                    sub_header: 18,
                    name: 'ot_inst_disinfec',
                    title: 'OT Instruments + Disinfection',
                    visible: true,
                    element: 'text',
                    row_group: 'ot_inst_disinfec',
                    table: 'ot_charges',
                }, {
                    id: 1,
                    service: null,
                    header: 9,
                    sub_header: 18,
                    name: 'qty',
                    title: 'OT Instruments + Disinfection Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'OT Instruments + Disinfection Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ot_inst_disinfec',
                    table: 'ot_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'OT Instruments + Disinfection Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'OT Instruments + Disinfection Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ot_inst_disinfec',
                    table: 'ot_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'OT Instruments + Disinfection Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'OT Instruments + Disinfection Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ot_inst_disinfec',
                    table: 'ot_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'ot_inst_disinfec',
                    table: 'ot_charges',
                }]
            },
            {
                'id': 2,
                'key_word': 'routine',
                'feilds': [{
                    id: 2,
                    service: 2,
                    header: 9,
                    sub_header: 40,
                    name: 'routine',
                    title: 'Routine OT Hours',
                    visible: true,
                    element: 'text',
                    tooltip:null,
                    row_group: 'routine',
                    table: 'ot_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ot_charges',
                    charge: 0,
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Routine Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ot_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Routine Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ot_charges',
                }, {
                    id: 2,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'ot_charges',
                },]
            },{
            'id': 3,
            'key_word': 'highend',
            'feilds': [{
                id: 3,
                service: 1,
                header: 9,
                sub_header: 17,
                name: 'ot_hours',
                title: 'Equipment Charges',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Equipment Type',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_charges',
            }, {
                id: 3,
                name: 'qty',
                title: 'OT Hours Quantity',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'OT Hours Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12',
                row_group: 'highend',
                table: 'ot_charges',
                charges: 0,
            }, {
                id: 3,
                name: 'rate',
                title: 'OT Hours Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'OT Hours Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_charges',
            }, {
                id: 3,
                name: 'amount',
                title: 'OT Hours Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'OT Hours Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_charges',
            }, {
                id: 3,
                name: 'action',
                title: '--',
                visible: true,
                element: 'text',
                row_group: 'highend',
                table: 'ot_charges',
            }]
        }],
            'add_more_feilds': [{
                id: 4,
                service: 1,
                header: 9,
                sub_header: 17,
                name: 'ot_hours',
                title: 'Equipment Charges',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Equipment Type',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_charges',
            }, {
                id: 4,
                name: 'qty',
                title: 'OT Hours Quantity',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'OT Hours Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12',
                row_group: 'highend',
                table: 'ot_charges',
                charges: 0,
            }, {
                id: 4,
                name: 'rate',
                title: 'OT Hours Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'OT Hours Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_charges',
            }, {
                id: 4,
                name: 'amount',
                title: 'OT Hours Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'OT Hours Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_charges',
            }, {
                id: 4,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'routine',
                table: 'ot_charges',
            }]
        }
    },
    //  {
    //     id: 10,
    //     name: 'ot_equipment',
    //     header: 10,
    //     header_amount: 0,
    //     title: 'OT Equipment',
    //     visible: true,
    //     Specification: {
    //         'type': 'table',
    //         'add_more': true,
    //         'add_more_title': 'Add OT Equipment',
    //         'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
    //         'table_body': [{
    //             'id': 1,
    //             'key_word': 'routine',
    //             'feilds': [{
    //                 id: 1,
    //                 service: 1,
    //                 header: 10,
    //                 sub_header: 36 ,
    //                 name: 'routine',
    //                 title: 'Routine',
    //                 visible: true,
    //                 element: 'text',
    //                 tooltip:null,
    //                 row_group: 'routine',
    //                 table: 'ot_equipment',
    //             }, {
    //                 id: 1,
    //                 name: 'qty',
    //                 title: 'Routine Quantity',
    //                 visible: true,
    //                 icon: 'number',
    //                 element: 'input',
    //                 required: true,
    //                 type: 'number',
    //                 placeholder: 'Routine',
    //                 rules: [],
    //                 errors: [],
    //                 value: null ,
    //                 valid: false,
    //                 state: '',
    //                 disable: true,
    //                 className: 'col-3',
    //                 row_group: 'routine',
    //                 table: 'ot_equipment',
    //             }, {
    //                 id: 1,
    //                 name: 'rate',
    //                 title: 'Routine Rate',
    //                 visible: true,
    //                 icon: 'number',
    //                 element: 'input',
    //                 required: true,
    //                 type: 'number',
    //                 placeholder: 'Routine Rate',
    //                 rules: [],
    //                 errors: [],
    //                 value: null,
    //                 valid: false,
    //                 state: '',
    //                 disable: false,
    //                 className: 'col-3',
    //                 row_group: 'routine',
    //                 table: 'ot_equipment',
    //             }, {
    //                 id: 1,
    //                 name: 'amount',
    //                 title: 'Routine Amount',
    //                 visible: true,
    //                 icon: 'number',
    //                 element: 'input',
    //                 required: true,
    //                 type: 'number',
    //                 placeholder: 'Routine Amount',
    //                 rules: [],
    //                 errors: [],
    //                 value: null,
    //                 valid: false,
    //                 state: '',
    //                 disable: true,
    //                 className: 'col-3',
    //                 row_group: 'routine',
    //                 table: 'ot_equipment',
    //             }, {
    //                 id: 1,
    //                 name: 'action',
    //                 title: '--',
    //                 visible: true,
    //                 element: 'text',
    //                 row_group: 'routine',
    //                 table: 'ot_equipment',
    //             },]
    //         },
    //         {
    //             'id': 1,
    //             'text': 'OT Equipment',
    //             'type': 'text',
    //             'key_word': 'highend',
    //             'input_feild': [],
    //             'feilds': [{
    //                 id: 1,
    //                 service: 1,
    //                 header: 10,
    //                 sub_header: 19,
    //                 name: 'ot_equipments',
    //                 title: '',
    //                 visible: true,
    //                 icon: 'number',
    //                 element: 'select',
    //                 required: true,
    //                 type: 'select',
    //                 placeholder: 'OT Equipment',
    //                 rules: [],
    //                 errors: [],
    //                 value: null,
    //                 valid: false,
    //                 state: '',
    //                 disable: false,
    //                 className: 'col-12 p-0',
    //                 row_group: 'highend',
    //                 table: 'ot_equipment',

    //             }, {
    //                 id: 1,
    //                 name: 'qty',
    //                 title: 'OT Equipment Qty.',
    //                 visible: true,
    //                 icon: 'number',
    //                 element: 'input',
    //                 required: true,
    //                 type: 'number',
    //                 placeholder: 'OT Equipment Quantity',
    //                 rules: [],
    //                 errors: [],
    //                 value: null,
    //                 valid: false,
    //                 state: '',
    //                 disable: false,
    //                 className: 'col-3',
    //                 row_group: 'highend',
    //                 table: 'ot_equipment',
    //             }, {
    //                 id: 1,
    //                 name: 'rate',
    //                 title: 'OT Equipment Rate',
    //                 visible: true,
    //                 icon: 'number',
    //                 element: 'input',
    //                 required: true,
    //                 type: 'number',
    //                 placeholder: 'OT Equipment Rate',
    //                 rules: [],
    //                 errors: [],
    //                 value: null,
    //                 valid: false,
    //                 state: '',
    //                 disable: true,
    //                 className: 'col-3',
    //                 row_group: 'highend',
    //                 table: 'ot_equipment',
    //             }, {
    //                 id: 1,
    //                 name: 'amount',
    //                 title: 'OT Equipment Amount',
    //                 visible: true,
    //                 icon: 'number',
    //                 element: 'input',
    //                 required: true,
    //                 type: 'number',
    //                 placeholder: 'OT Equipment Amount',
    //                 rules: [],
    //                 errors: [],
    //                 value: null,
    //                 valid: false,
    //                 state: '',
    //                 disable: true,
    //                 className: 'col-3',
    //                 row_group: 'highend',
    //                 table: 'ot_equipment',
    //             }, {
    //                 id: 1,
    //                 name: 'action',
    //                 title: '--',
    //                 visible: true,
    //                 element: 'action',
    //                 row_group: 'highend',
    //                 table: 'ot_equipment',
    //             }]
    //         }],
    //         'add_more_feilds': [{
    //             id: 1,
    //             service: null,
    //             header: 10,
    //             sub_header: 19,
    //             name: 'ot_equipments',
    //             title: '',
    //             visible: true,
    //             icon: 'number',
    //             element: 'select',
    //             required: true,
    //             type: 'select',
    //             placeholder: 'OT Equipment',
    //             rules: [],
    //             errors: [],
    //             value: null,
    //             valid: false,
    //             state: '',
    //             disable: false,
    //             className: 'col-12 p-0',
    //             row_group: 'routine',
    //             table: 'ot_equipment',
    //         }, {
    //             id: 1,
    //             name: 'qty',
    //             title: 'OT Equipment Qty.',
    //             visible: true,
    //             icon: 'number',
    //             element: 'input',
    //             required: true,
    //             type: 'number',
    //             placeholder: 'OT Equipment Quantity',
    //             rules: [],
    //             errors: [],
    //             value: 1,
    //             valid: false,
    //             state: '',
    //             disable: false,
    //             className: 'col-3',
    //             row_group: 'routine',
    //             table: 'ot_equipment',
    //         }, {
    //             id: 1,
    //             name: 'rate',
    //             title: 'OT Equipment Rate',
    //             visible: true,
    //             icon: 'number',
    //             element: 'input',
    //             required: true,
    //             type: 'number',
    //             placeholder: 'OT Equipment Rate',
    //             rules: [],
    //             errors: [],
    //             value: null,
    //             valid: false,
    //             state: '',
    //             disable: true,
    //             className: 'col-3',
    //             row_group: 'routine',
    //             table: 'ot_equipment',
    //         }, {
    //             id: 1,
    //             name: 'amount',
    //             title: 'OT Equipment Amount',
    //             visible: true,
    //             icon: 'number',
    //             element: 'input',
    //             required: true,
    //             type: 'number',
    //             placeholder: 'OT Equipment Amount',
    //             rules: [],
    //             errors: [],
    //             value: null,
    //             valid: false,
    //             state: '',
    //             disable: true,
    //             className: 'col-3',
    //             row_group: 'routine',
    //             table: 'ot_equipment',
    //         }, {
    //             id: 1,
    //             name: 'action',
    //             title: '--',
    //             visible: true,
    //             element: 'action',
    //             row_group: 'routine',
    //             table: 'ot_equipment',
    //         }]
    //     }
    // },
    {
        id: 10,
        name: 'ot_equipment',
        header: 10,
        header_amount: 0,
        title: 'OT Equipment',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add OT Equipment',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'routine',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 10,
                    sub_header: 36 ,
                    name: 'routine',
                    title: 'Routine',
                    visible: true,
                    element: 'text',
                    tooltip:null,
                    row_group: 'routine',
                    table: 'ot_equipment',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Routine Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine',
                    rules: [],
                    errors: [],
                    value: null ,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ot_equipment',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ot_equipment',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ot_equipment',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'ot_equipment',
                },]
            },
                {
                'id': 2,
                'key_word': 'highend',
                'feilds': [{
                    id: 2,
                    service: 11,
                    header: 11,
                    sub_header: 20,
                    name: 'surgery_procedure_name',
                    title: 'Procedure',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Procedure',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ot_equipment',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'OT Equipment Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'OT Equipment Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ot_equipment',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'OT Equipment Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'OT Equipment Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ot_equipment',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'OT Equipment Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'OT Equipment Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ot_equipment',
                }, {
                    id: 2,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'highend',
                    table: 'ot_equipment',
                }]
            },
        ],
            'add_more_feilds': [{
                id: 1,
                service: 1,
                header: 10,
                sub_header: 19,
                name: 'ot_equipments',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'OT Equipment',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'highend',
                table: 'ot_equipment',
            }, {
                id: 1,
                name: 'qty',
                title: 'OT Equipment Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'OT Equipment Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_equipment',
            }, {
                id: 1,
                name: 'rate',
                title: 'OT Equipment Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'OT Equipment Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_equipment',
            }, {
                id: 1,
                name: 'amount',
                title: 'OT Equipment Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'OT Equipment Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_equipment',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'highend',
                table: 'ot_equipment',
            }]
        }
    },
     {
        id: 11,
        name: 'procedure_charges',
        header: 11,
        header_amount: 0,
        title: 'Procedure Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Procedure',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'routine',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 11,
                    sub_header: 37,
                    name: 'routine',
                    title: 'Routine',
                    visible: true,
                    element: 'text',
                    tooltip:null,
                    row_group: 'routine',
                    table: 'procedure_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Routine Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine',
                    rules: [],
                    errors: [],
                    value: null ,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'procedure_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'procedure_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'procedure_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'procedure_charges',
                }]
            },
                {
                'id': 2,
                'key_word': 'highend',
                'feilds': [{
                    id: 2,
                    service: 11,
                    header: 11,
                    sub_header: 20,
                    name: 'surgery_procedure_name',
                    title: 'Procedure',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Procedure',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'procedure_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Procedure Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Procedure Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'procedure_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Procedure Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Procedure Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'procedure_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Procedure Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Procedure Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'procedure_charges',
                }, {
                    id: 2,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'highend',
                    table: 'procedure_charges',
                }]
            },
        ],
            'add_more_feilds': [{
                id: 1,
                service: null,
                header: 11,
                sub_header: 20,
                name: 'surgery_procedure_name',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Procedure',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'highend',
                table: 'procedure_charges',
            }, {
                id: 1,
                name: 'qty',
                title: 'Procedure Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Procedure Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'highend',
                table: 'procedure_charges',
            }, {
                id: 1,
                name: 'rate',
                title: 'Procedure Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Procedure Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'procedure_charges',
            }, {
                id: 1,
                name: 'amount',
                title: 'Procedure Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Procedure Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'procedure_charges',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'highend',
                table: 'procedure_charges',
            }]
        }
    }, 
    // {
    //     id: 12,
    //     name: 'blood_bank_charges',
    //     header: 12,
    //     header_amount: 0,
    //     title: 'Blood Bank Charges',
    //     visible: true,
    //     Specification: {
    //         'type': 'table',
    //         'add_more': true,
    //         'add_more_title': 'Add Blood Bank Component',
    //         'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
    //         'table_body': [{
    //             'id': 1,
    //             'key_word': 'routine',
    //             'feilds': [{
    //                 id: 1,
    //                 service: 1,
    //                 header: 12,
    //                 sub_header: 38 ,
    //                 name: 'routine',
    //                 title: 'Routine',
    //                 visible: true,
    //                 element: 'text',
    //                 tooltip:null,
    //                 row_group: 'routine',
    //                 table: 'blood_bank_charges',
    //             }, {
    //                 id: 1,
    //                 name: 'qty',
    //                 title: 'Routine Quantity',
    //                 visible: true,
    //                 icon: 'number',
    //                 element: 'input',
    //                 required: true,
    //                 type: 'number',
    //                 placeholder: 'Routine',
    //                 rules: [],
    //                 errors: [],
    //                 value: null ,
    //                 valid: false,
    //                 state: '',
    //                 disable: true,
    //                 className: 'col-3',
    //                 row_group: 'routine',
    //                 table: 'blood_bank_charges',
    //             }, {
    //                 id: 1,
    //                 name: 'rate',
    //                 title: 'Routine Rate',
    //                 visible: true,
    //                 icon: 'number',
    //                 element: 'input',
    //                 required: true,
    //                 type: 'number',
    //                 placeholder: 'Routine Rate',
    //                 rules: [],
    //                 errors: [],
    //                 value: null,
    //                 valid: false,
    //                 state: '',
    //                 disable: false,
    //                 className: 'col-3',
    //                 row_group: 'routine',
    //                 table: 'blood_bank_charges',
    //             }, {
    //                 id: 1,
    //                 name: 'amount',
    //                 title: 'Routine Amount',
    //                 visible: true,
    //                 icon: 'number',
    //                 element: 'input',
    //                 required: true,
    //                 type: 'number',
    //                 placeholder: 'Routine Amount',
    //                 rules: [],
    //                 errors: [],
    //                 value: null,
    //                 valid: false,
    //                 state: '',
    //                 disable: true,
    //                 className: 'col-3',
    //                 row_group: 'routine',
    //                 table: 'blood_bank_charges',
    //             }, {
    //                 id: 1,
    //                 name: 'action',
    //                 title: '--',
    //                 visible: true,
    //                 element: 'text',
    //                 row_group: 'routine',
    //                 table: 'blood_bank_charges',
    //             },]
    //         },
    //             {
    //             'id': 1,
    //             'key_word': 'highend',
    //             'feilds': [{
    //                 id: 1,
    //                 service: 1,
    //                 header: 12,
    //                 sub_header: 21,
    //                 name: 'blood_components',
    //                 title: 'Blood Bank Charges',
    //                 visible: true,
    //                 icon: 'number',
    //                 element: 'select',
    //                 required: true,
    //                 type: 'select',
    //                 placeholder: 'Blood Bank Charges',
    //                 rules: [],
    //                 errors: [],
    //                 value: 1,
    //                 valid: false,
    //                 state: '',
    //                 disable: false,
    //                 className: 'col-3',
    //                 row_group: 'highend',
    //                 table: 'blood_bank_charges',
    //             }, {
    //                 id: 1,
    //                 name: 'qty',
    //                 title: 'Blood Bank Charges Quantity',
    //                 visible: true,
    //                 icon: 'number',
    //                 element: 'input',
    //                 required: true,
    //                 type: 'number',
    //                 placeholder: 'Blood Bank Charges Quantity',
    //                 rules: [],
    //                 errors: [],
    //                 value: null,
    //                 valid: false,
    //                 state: '',
    //                 disable: false,
    //                 className: 'col-3',
    //                 row_group: 'highend',
    //                 table: 'blood_bank_charges',
    //             }, {
    //                 id: 1,
    //                 name: 'rate',
    //                 title: 'Blood Bank Charges Rate',
    //                 visible: true,
    //                 icon: 'number',
    //                 element: 'input',
    //                 required: true,
    //                 type: 'number',
    //                 placeholder: 'Blood Bank Charges Rate',
    //                 rules: [],
    //                 errors: [],
    //                 value: null,
    //                 valid: false,
    //                 state: '',
    //                 disable: true,
    //                 className: 'col-3',
    //                 row_group: 'highend',
    //                 table: 'blood_bank_charges',
    //             }, {
    //                 id: 1,
    //                 name: 'amount',
    //                 title: 'Blood Bank Charges Amount',
    //                 visible: true,
    //                 icon: 'number',
    //                 element: 'input',
    //                 required: true,
    //                 type: 'number',
    //                 placeholder: 'Blood Bank Charges Amount',
    //                 rules: [],
    //                 errors: [],
    //                 value: null,
    //                 valid: false,
    //                 state: '',
    //                 disable: true,
    //                 className: 'col-3',
    //                 row_group: 'highend',
    //                 table: 'blood_bank_charges',
    //             }, {
    //                 id: 1,
    //                 name: 'action',
    //                 title: '--',
    //                 visible: true,
    //                 element: 'action',
    //                 row_group: 'highend',
    //                 table: 'blood_bank_charges',
    //             }]
    //         }],
    //         'add_more_feilds': [{
    //             id: 1,
    //             service: null,
    //             header: 12,
    //             sub_header: 21,
    //             name: 'blood_components',
    //             title: '',
    //             visible: true,
    //             icon: 'number',
    //             element: 'select',
    //             required: true,
    //             type: 'select',
    //             placeholder: 'Blood Bank Charges',
    //             rules: [],
    //             errors: [],
    //             value: null,
    //             valid: false,
    //             state: '',
    //             disable: false,
    //             className: 'col-12 p-0',
    //             row_group: 'highend',
    //             table: 'blood_bank_charges',
    //         }, {
    //             id: 1,
    //             name: 'qty',
    //             title: 'Blood Bank Charges Qty.',
    //             visible: true,
    //             icon: 'number',
    //             element: 'input',
    //             required: true,
    //             type: 'number',
    //             placeholder: 'Blood Bank Charges Quantity',
    //             rules: [],
    //             errors: [],
    //             value: 1,
    //             valid: false,
    //             state: '',
    //             disable: false,
    //             className: 'col-3',
    //             row_group: 'highend',
    //             table: 'blood_bank_charges',
    //         }, {
    //             id: 1,
    //             name: 'rate',
    //             title: 'Blood Bank Charges Rate',
    //             visible: true,
    //             icon: 'number',
    //             element: 'input',
    //             required: true,
    //             type: 'number',
    //             placeholder: 'Blood Bank Charges Rate',
    //             rules: [],
    //             errors: [],
    //             value: null,
    //             valid: false,
    //             state: '',
    //             disable: true,
    //             className: 'col-3',
    //             row_group: 'highend',
    //             table: 'blood_bank_charges',
    //         }, {
    //             id: 1,
    //             name: 'amount',
    //             title: 'Blood Bank Charges Amount',
    //             visible: true,
    //             icon: 'number',
    //             element: 'input',
    //             required: true,
    //             type: 'number',
    //             placeholder: 'Blood Bank Charges Amount',
    //             rules: [],
    //             errors: [],
    //             value: null,
    //             valid: false,
    //             state: '',
    //             disable: true,
    //             className: 'col-3',
    //             row_group: 'highend',
    //             table: 'blood_bank_charges',
    //         }, {
    //             id: 1,
    //             name: 'action',
    //             title: '--',
    //             visible: true,
    //             element: 'action',
    //             row_group: 'highend',
    //             table: 'blood_bank_charges',
    //         }]
    //     }
    // },
    {
        id: 12,
        name: 'blood_bank_charges',
        header: 12,
        header_amount: 0,
        title: 'Blood Bank Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Blood Bank Component',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'routine',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 12,
                    sub_header: 38 ,
                    name: 'routine',
                    title: 'Routine',
                    visible: true,
                    element: 'text',
                    tooltip:null,
                    row_group: 'routine',
                    table: 'blood_bank_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Routine Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine',
                    rules: [],
                    errors: [],
                    value: null ,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'blood_bank_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'blood_bank_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'blood_bank_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'blood_bank_charges',
                },]
            },
                {
                'id': 2,
                'key_word': 'highend',
                'feilds': [{
                    id: 2,
                    service: 12,
                    header: 12,
                    sub_header: 21,
                    name: 'blood_components',
                    title: 'Blood Bank Charges',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Blood Bank Charges',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'blood_bank_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Blood Bank Charges Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Blood Bank Charges Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'blood_bank_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Blood Bank Charges Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Blood Bank Charges Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'blood_bank_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Blood Bank Charges Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Blood Bank Charges Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'blood_bank_charges',
                }, {
                    id: 2,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'highend',
                    table: 'blood_bank_charges',
                }]
            }],
            'add_more_feilds': [{
                id: 1,
                service: 1,
                header: 12,
                sub_header: 21,
                name: 'blood_components',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Blood Bank Charges',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'highend',
                table: 'blood_bank_charges',
            }, {
                id: 1,
                name: 'qty',
                title: 'Blood Bank Charges Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Blood Bank Charges Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'highend',
                table: 'blood_bank_charges',
            }, {
                id: 1,
                name: 'rate',
                title: 'Blood Bank Charges Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Blood Bank Charges Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'blood_bank_charges',
            }, {
                id: 1,
                name: 'amount',
                title: 'Blood Bank Charges Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Blood Bank Charges Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'blood_bank_charges',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'highend',
                table: 'blood_bank_charges',
            }]
        }
    },
     {
        id: 13,
        name: 'cross_consultation_charges',
        header: 13,
        header_amount: 0,
        title: 'Cross Consultation Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Cross Consultation',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'routine',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 13,
                    sub_header: 22,
                    name: 'dept_for_corss_consultations',
                    title: 'Select Department',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Select Department',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'cross_consultation_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Cross Consultation Charges Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Cross Consultation Charges Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'cross_consultation_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Cross Consultation Charges Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Cross Consultation Charges Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'cross_consultation_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Cross Consultation Charges Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Cross Consultation Charges Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'cross_consultation_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'routine',
                    table: 'cross_consultation_charges',
                }]
            }],
            'add_more_feilds': [{
                id: 2,
                service: null,
                header: 13,
                sub_header: 22,
                name: 'dept_for_corss_consultations',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Select Department',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'routine',
                table: 'cross_consultation_charges',
            }, {
                id: 2,
                name: 'qty',
                title: 'Cross Consultation Charges Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Cross Consultation Charges Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'routine',
                table: 'cross_consultation_charges',
            }, {
                id: 2,
                name: 'rate',
                title: 'Cross Consultation Charges Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Cross Consultation Charges Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'routine',
                table: 'cross_consultation_charges',
            }, {
                id: 2,
                name: 'amount',
                title: 'Cross Consultation Charges Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Cross Consultation Charges Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'routine',
                table: 'cross_consultation_charges',
            }, {
                id: 2,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'routine',
                table: 'cross_consultation_charges',
            }]
        }
    }, {
        id: 14,
        name: 'hospital_services',
        header: 14,
        header_amount: 0,
        title: 'Hospital Services',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Seropsitive',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" },
            { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'mrd',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 14,
                    sub_header: 23,
                    name: 'mrd',
                    title: 'MRD',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'hospital_services',
                }, {
                    id: 1,
                    name: 'qty',
                    header: 14,
                    sub_header: 23,
                    title: 'MRD Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'MRD Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'hospital_services',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'MRD Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'MRD Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'hospital_services',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'MRD Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'MRD Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'hospital_services',
                },{
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'hospital_services',
                }]
            },{
                'id': 2,
                'key_word': 'ward_consumables',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 14,
                    sub_header: 41,
                    name: 'Ward_consumables',
                    title: 'Ward Consumables',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'hospital_services',
                }, {
                    id: 1,
                    name: 'qty',
                    header: 14,
                    sub_header: 41,
                    title: 'Ward Consumables Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Ward Consumables Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'hospital_services',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Ward Consumables Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Ward Consumables Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'hospital_services',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Ward Consumables Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Ward Consumables Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'hospital_services',
                },{
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'hospital_services',
                }]
            },
             {
                'id': 3,
                'key_word': 'seropositive',
                'feilds': [{
                    id: 2,
                    service: 24,
                    header: 14,
                    sub_header: 24,
                    name: 'seropositive',
                    // title: 'Seropositive',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Select Department',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-12 p-0',
                    row_group: 'seropositive',
                    table: 'hospital_services',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Seropositive Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Seropositive Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'seropositive',
                    table: 'hospital_services',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Seropositive Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Seropositive Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'seropositive',
                    table: 'hospital_services',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Seropositive Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Seropositive Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'seropositive',
                    table: 'hospital_services',
                },
                {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'seropositive',
                    table: 'hospital_services',
                }]
            }],
            'add_more_feilds': [{
                id: 4,
                service: null,
                header: 14,
                sub_header: 24,
                name: 'seropositive',
                // title: 'Seropositive',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Select Department',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'seropositive',
                table: 'hospital_services',
            }, {
                id: 3,
                name: 'qty',
                title: 'Seropositive Quantity',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Seropositive Quantity',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'seropositive',
                table: 'hospital_services',
            }, {
                id: 3,
                name: 'rate',
                title: 'Seropositive Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Seropositive Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'seropositive',
                table: 'hospital_services',
            }, {
                id: 3,
                name: 'amount',
                title: 'Seropositive Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Seropositive Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'seropositive',
                table: 'hospital_services',
            },{
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'seropositive',
                table: 'hospital_services',
            }]
        }
    }, {
        id: 15,
        name: 'isolation_charges',
        header: 15,
        header_amount: 0,
        title: 'Isolation Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'routine',
                'feilds': [{
                    id: 1,
                    service: null,
                    header: 15,
                    sub_header: 25,
                    name: 'room_isolation_charges',
                    title: 'Room Charges',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Room Charges',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-12',
                    row_group: 'room_isolation_charges',
                    table: 'isolation_charges',

                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Room Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Room Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'room_isolation_charges',
                    table: 'isolation_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Room Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Room Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'room_isolation_charges',
                    table: 'isolation_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Room Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Room Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'room_isolation_charges',
                    table: 'isolation_charges',
                }]
            }, {
                'id': 2,
                'key_word': 'highend',
                'feilds': [{
                    id: 2,
                    service: null,
                    header: 15,
                    sub_header: 26,
                    name: 'icu_isolation_charges',
                    title: 'ICU charges',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'ICU charges',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-12',
                    row_group: 'icu_isolation_charges',
                    table: 'isolation_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'ICU Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'ICU Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'icu_isolation_charges',
                    table: 'isolation_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'ICU Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'ICU Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'icu_isolation_charges',
                    table: 'isolation_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'ICU Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'ICU Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'icu_isolation_charges',
                    table: 'isolation_charges',
                }]
            }]
        }
    }, {
        id: 16,
        name: 'physiotherapy_diet_charges',
        header: 16,
        header_amount: 0,
        title: 'Physiotherapy & Diet Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Physiotherapy',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" },{ 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [
                {
                'id': 1,
                'key_word': 'dietician',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 16,
                    sub_header: 27,
                    name: 'dietician',
                    title: 'Dietician',
                    visible: true,
                    element: 'text',
                    row_group: 'dietician',
                    tooltip:null,
                    table: 'physiotherapy_diet_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    header: 16,
                    sub_header: 27,
                    title: 'Dietician Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Dietician Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'dietician',
                    table: 'physiotherapy_diet_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Dietician Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Dietician Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'dietician',
                    table: 'physiotherapy_diet_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Dietician Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Dietician Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'dietician',
                    table: 'physiotherapy_diet_charges',
                },
                {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'dietician',
                    table: 'physiotherapy_diet_charges',
                }]
            },{
                'id': 2,
                'key_word': 'routine',
                'feilds': [{
                    id: 2,
                    service: 1,
                    header: 16,
                    sub_header: 39,
                    name: 'routine',
                    title: 'Physiotherapy Routine',
                    visible: true,
                    element: 'text',
                    tooltip:null,
                    row_group: 'routine',
                    table: 'physiotherapy_diet_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Routine Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine',
                    rules: [],
                    errors: [],
                    value: null ,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'physiotherapy_diet_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Routine Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'physiotherapy_diet_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Routine Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'physiotherapy_diet_charges',
                }, {
                    id: 2,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'physiotherapy_diet_charges',
                },]
            },
             {
                'id': 3,
                'key_word': 'highend',
                'feilds': [{
                    id: 3,
                    service: null,
                    header: 16,
                    sub_header: 28,
                    name: 'physiotherapys',
                    title: 'Physiotherapy',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Physiotherapy',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'physiotherapys',
                    table: 'physiotherapy_diet_charges',

                }, {
                    id: 3,
                    name: 'qty',
                    title: 'Physiotherapy Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Physiotherapy Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'physiotherapys',
                    table: 'physiotherapy_diet_charges',
                }, {
                    id: 3,
                    name: 'rate',
                    title: 'Physiotherapy Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Physiotherapy Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'physiotherapys',
                    table: 'physiotherapy_diet_charges',
                }, {
                    id: 3,
                    name: 'amount',
                    title: 'Physiotherapy Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Physiotherapy Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'physiotherapys',
                    table: 'physiotherapy_diet_charges',
                },{
                    id: 3,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'physiotherapys',
                    table: 'physiotherapy_diet_charges',
                }]
            }],
            'add_more_feilds': [{
                id: 4,
                service: null,
                header: 16,
                sub_header: 28,
                name: 'physiotherapys',
                title: 'Physiotherapy',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Physiotherapy',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'physiotherapys',
                table: 'physiotherapy_diet_charges',

            }, {
                id: 4,
                name: 'qty',
                title: 'Physiotherapy Quantity',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Physiotherapy Quantity',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'physiotherapys',
                table: 'physiotherapy_diet_charges',
            }, {
                id: 4,
                name: 'rate',
                title: 'Physiotherapy Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Physiotherapy Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'physiotherapys',
                table: 'physiotherapy_diet_charges',
            }, {
                id: 4,
                name: 'amount',
                title: 'Physiotherapy Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Physiotherapy Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'physiotherapys',
                table: 'physiotherapy_diet_charges',
            },{
                id: 4,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'physiotherapys',
                table: 'physiotherapy_diet_charges',
            }]
        }
    },
    {
        id: 17,
        name: 'surgical_charges',
        header: 17,
        header_amount: 0,
        title: 'Surgical Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "40%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'additional_surgeon_fees',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 17,
                    sub_header: 42,
                    name: 'additional_surgeon_fees',
                    title: 'Additional Surgeon Fees',
                    visible: true,
                    element: 'text',
                }, {
                    id: 1,
                    name: 'percentage',
                    title: 'Surgeon Amount',
                    visible: false,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Surgeon Percentage',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'additional_surgeon_fees',
                    table: 'surgical_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Surgeon Percentage',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Surgeon Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'additional_surgeon_fees',
                    table: 'surgical_charges',
                }]
            },
                {
                'id': 2,
                'key_word': 'surgeon',
                'feilds': [{
                    id: 2,
                    service: 1,
                    header: 17,
                    sub_header: 29,
                    name: 'surgeon',
                    title: 'Surgeon',
                    visible: true,
                    element: 'text',
                }, {
                    id: 2,
                    name: 'percentage',
                    title: 'Surgeon Amount',
                    visible: false,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Surgeon Percentage',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'surgeon',
                    table: 'surgical_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Surgeon Percentage',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Surgeon Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'surgeon',
                    table: 'surgical_charges',
                }]
            }, {
                'id': 3,
                'key_word': 'asst_surgeon',
                'feilds': [{
                    id: 3,
                    service: 2,
                    header: 17,
                    sub_header: 30,
                    name: 'asst_surgeon',
                    title: 'Asst Surgeon',
                    visible: true,
                    element: 'text',

                }, {
                    id: 3,
                    name: 'percentage',
                    title: 'Asst Surgeon Percentage',
                    visible: false,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Surgeon Percentage',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'surgeon',
                    table: 'surgical_charges',
                }, {
                    id: 3,
                    name: 'amount',
                    title: 'Asst Surgeon Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Surgeon Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'asst_surgeon',
                    table: 'surgical_charges',
                }]
            }, {
                'id': 4,
                'key_word': 'anaesthetist',
                'feilds': [{
                    id: 4,
                    service: 3,
                    header: 17,
                    sub_header: 31,
                    name: 'anaesthetist',
                    title: 'Anaesthetist',
                    visible: true,
                    element: 'text',

                }, {
                    id: 4,
                    name: 'percentage',
                    title: 'Anaesthetist Percentage',
                    visible: false,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Surgeon Percentage',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'surgeon',
                    table: 'surgical_charges',
                }, {
                    id: 4,
                    name: 'amount',
                    title: 'Anaesthetist Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Anaesthetist Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'anaesthetist',
                    table: 'surgical_charges',
                }]
            }, {
                'id': 5,
                'key_word': 'asst_anaesthetist',
                'feilds': [{
                    id: 5,
                    service: 4,
                    header: 17,
                    sub_header: 32,
                    name: 'asst_anaesthetist',
                    title: 'Asst Anaesthetist',
                    visible: true,
                    element: 'text',

                }, {
                    id: 5,
                    name: 'percentage',
                    title: 'Asst Anaesthetist Percentage',
                    visible: false,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Surgeon Percentage',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'surgeon',
                    table: 'surgical_charges',
                }, {
                    id: 5,
                    name: 'amount',
                    title: 'Asst Anaesthetist Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Anaesthetist Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'asst_anaesthetist',
                    table: 'surgical_charges',
                }]
            }, {
                'id': 6,
                'key_word': 'consultation_charges_room',
                'feilds': [{
                    id: 6,
                    service: 2,
                    header: 17,
                    sub_header: 46,
                    name: 'consultationcharges_room',
                    title: 'Consultation Charges Room',
                    visible: true,
                    element: 'text',

                }, {
                    id: 6,
                    name: 'percentage',
                    title: 'Consultation Charges Room Percentage',
                    visible: false,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Consultation Charges Room Percentage',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'consultation_charges_room',
                    table: 'surgical_charges',
                }, {
                    id: 6,
                    name: 'amount',
                    title: 'Consultation Charges Room Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Consultation Charges Room Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'consultation_charges_room',
                    table: 'surgical_charges',
                },]
            },
            {
                'id': 7,
                'key_word': 'consultation_charges_icu',
                'feilds': [{
                    id: 7,
                    service: 2,
                    header: 17,
                    sub_header: 47,
                    name: 'consultation_charges_icu',
                    title: 'Consultation Charges ICU',
                    visible: true,
                    element: 'text',

                }, {
                    id: 7,
                    name: 'percentage',
                    title: 'Consultation Charges ICU Percentage',
                    visible: false,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Consultation Charges ICU Percentage',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'consultation_charges_icu',
                    table: 'surgical_charges',
                }, {
                    id: 7,
                    name: 'amount',
                    title: 'Consultation Charges ICU Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Consultation Charges ICU Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'consultation_charges_icu',
                    table: 'surgical_charges',
                },]
            }
            ]
        }
    }, {
        id: 18,
        name: 'medical_charges',
        header: 18,
        header_amount: 0,
        title: 'Medical Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "40%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'Additional_physician_fees',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 18,
                    sub_header: 43,
                    name: 'Additional_physician_fees',
                    title: 'Additional Physician Fees',
                    visible: true,
                    element: 'text',
                },  {
                    id: 1,
                    name: 'percentage',
                    title: 'Physician Fees Percentage',
                    visible: false,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Physician Fees Percentage',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'Additional_physician_fees',
                    table: 'medical_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Physician Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Physician Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'Additional_physician_fees',
                    table: 'medical_charges',
                }]
            },
            {    'id': 2,
                'key_word': 'physician_fees',
                'feilds': [{
                    id: 2,
                    service: 1,
                    header: 18,
                    sub_header: 33,
                    name: 'physician_fees',
                    title: 'Physician Fees',
                    visible: true,
                    element: 'text',
                },  {
                    id: 2,
                    name: 'percentage',
                    title: 'Physician Fees Percentage',
                    visible: false,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Physician Fees Percentage',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'physician_fees',
                    table: 'medical_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Physician Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Physician Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'physician_fees',
                    table: 'medical_charges',
                }]
            }, {
                'id': 3,
                'key_word': 'asst_physician_fees',
                'feilds': [{
                    id: 3,
                    service: 2,
                    header: 18,
                    sub_header: 34,
                    name: 'asst_physician_fees',
                    title: 'Asst Physician Fees',
                    visible: true,
                    element: 'text',

                }, {
                    id: 3,
                    name: 'percentage',
                    title: 'Asst Physician Fees Percentage',
                    visible: false,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Physician Fees Percentage',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'asst_physician_fees',
                    table: 'medical_charges',
                }, {
                    id: 3,
                    name: 'amount',
                    title: 'Asst Physician Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Physician Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'asst_physician_fees',
                    table: 'medical_charges',
                },]
            },
            {
                'id': 6,
                'key_word': 'consultation_charges_room',
                'feilds': [{
                    id: 6,
                    service: 2,
                    header: 18,
                    sub_header: 44,
                    name: 'consultationcharges_room',
                    title: 'Consultation Charges Room',
                    visible: true,
                    element: 'text',

                }, {
                    id: 6,
                    name: 'percentage',
                    title: 'Consultation Charges Room Percentage',
                    visible: false,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Consultation Charges Room Percentage',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'consultation_charges_room',
                    table: 'medical_charges',
                }, {
                    id: 6,
                    name: 'amount',
                    title: 'Consultation Charges Room Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Consultation Charges Room Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'consultation_charges_room',
                    table: 'medical_charges',
                },]
            },
            {
                'id': 7,
                'key_word': 'consultation_charges_icu',
                'feilds': [{
                    id: 7,
                    service: 2,
                    header: 18,
                    sub_header: 45,
                    name: 'consultation_charges_icu',
                    title: 'Consultation Charges ICU',
                    visible: true,
                    element: 'text',

                }, {
                    id: 7,
                    name: 'percentage',
                    title: 'Consultation Charges ICU Percentage',
                    visible: false,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Consultation Charges ICU Percentage',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'consultation_charges_icu',
                    table: 'medical_charges',
                }, {
                    id: 7,
                    name: 'amount',
                    title: 'Consultation Charges ICU Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Consultation Charges ICU Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'consultation_charges_icu',
                    table: 'medical_charges',
                },]
            }
        ]
        }
    },
    {
        id: 1,
        name: 'intensivist',
        header: 1,
        header_amount: 0,
        title: '',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id': 3,
                'key_word': 'intensivist',
                'feilds': [{
                    id: 1,
                    service: 3,
                    sub_header: 3,
                    name: 'intensivist',
                    title: 'Intensivist',
                    visible: true,
                    element: 'text',
                    row_group: 'intensivist',
                    table: 'intensivist',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'intensivist',
                    table: 'intensivist',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Intensivist Charges Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Intensivist Charges Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'intensivist',
                    table: 'intensivist',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Intensivist Charges Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Intensivist Charges Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'intensivist',
                    table: 'intensivist',
                }]
            },
            {
                'id': 4,
                'key_word': 'asst_intensivist',
                'feilds': [{
                    id: 1,
                    service: 4,
                    sub_header: 4,
                    name: 'asst_intensivist',
                    title: 'Asst. Intensivist',
                    visible: true,
                    element: 'text',
                    row_group: 'asst_intensivist',
                    table: 'intensivist',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'asst_intensivist',
                    table: 'intensivist',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Asst. Intensivist Charges Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst. Intensivist Charges Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'asst_intensivist',
                    table: 'intensivist',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Asst. Intensivist Charges Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst. Intensivist Charges Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'asst_intensivist',
                    table: 'intensivist',
                }]
            }

            ],
            'add_more_feilds': [],
        }
    },
]
        }

const roomtypeSchema = {
            feilds: [{
                id: 1,
                name: 'roomtypes',
                title: 'Select Room',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Select',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3 mx-auto',
            }]
        }

const includesSchema = {
            feilds: [{
                id: 1,
                header: 1,
                name: 'includes',
                title: 'Includes',
                visible: true,
                Specification: {
                    'type': 'table',
                    'add_more': false,
                    'add_more_title': null,
                    // 'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "40%" },{'id': 2, 'text': 'Quantity', width: "40%" }, {'id': 2, 'text': 'Rate (Rs.)', width: "40%" },{'id': 2, 'text': 'Amount (Rs.)', width: "40%" }],
                    'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, {'id': 2, 'text': 'Package Name', width: "30%" }, { 'id': 3, 'text': 'Serivce Type', width: "15%" }, { 'id': 4, 'text': 'Dept./ServiceGroup', width: "25%" }, { 'id': 5, 'text': 'Service Name', width: "25%" }, { 'id': 6, 'text': 'Quantity', width: "18%" }, { 'id': 7, 'text': 'Rate (Rs.)', width: "18%" }, { 'id': 8, 'text': 'Amount (Rs.)', width: "18%" }, { 'id': 9, 'text': 'EquServiceCode', width: "18%" }, { 'id': 10, 'text': 'IsActive', width: "18%" }, { 'id': 11, 'text': 'Ward Name', width: "45%" },{ 'id': 12, 'text': 'Level1 Desc', width: "45%" }],
                    // 'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "20%" }, { 'id': 3, 'text': 'Quantity', width: "25%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "25%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "25%" }],
                    'table_body': [
                        //     {
                        //     'id': 1,

                        //     'feilds': [{
                        //         id: 1,
                        //         name: 'item_service',
                        //         title: 'Item / Service',
                        //         visible: true,
                        //         element: 'text',

                        //     }, {
                        //         id: 1,
                        //         name: 'qty',
                        //         title: 'Includes Qty.',
                        //         visible: true,
                        //         icon: 'number',
                        //         element: 'input',
                        //         required: true,
                        //         type: 'number',
                        //         placeholder: 'Includes Quantity',
                        //         rules: [],
                        //         errors: [],
                        //         value: null,
                        //         valid: false,
                        //         state: '',
                        //         disable: true,
                        //         className: 'col-3',
                        //         row_group: 'Room',
                        //         column_group: 'qty',
                        //     }, {
                        //         id: 1,
                        //         name: 'rate',
                        //         title: 'Includes Rate',
                        //         visible: true,
                        //         icon: 'number',
                        //         element: 'input',
                        //         required: true,
                        //         type: 'number',
                        //         placeholder: 'Includes Rate',
                        //         rules: [],
                        //         errors: [],
                        //         value: null,
                        //         valid: false,
                        //         state: '',
                        //         disable: true,
                        //         className: 'col-3',
                        //         row_group: 'Room',
                        //         column_group: 'rate',
                        //     }, {
                        //         id: 1,
                        //         name: 'amount',
                        //         title: 'Includes Amount',
                        //         visible: true,
                        //         icon: 'number',
                        //         element: 'input',
                        //         required: true,
                        //         type: 'number',
                        //         placeholder: 'Includes Amount',
                        //         rules: [],
                        //         errors: [],
                        //         value: null,
                        //         valid: false,
                        //         state: '',
                        //         disable: true,
                        //         className: 'col-3',
                        //         row_group: 'Room',
                        //         column_group: 'amount',
                        //     }]
                        // }
                    ],
                    'add_more_feilds': [
                    {
                        d: 1,
                        name: 'item_package',
                        title: 'Item / package',
                        visible: true,
                        element: 'text',  
                    },
                    {
                        d: 1,
                        name: 'servicetype',
                        title: 'Service Type',
                        visible: true,
                        element: 'text',  
                    },
                    {
                        d: 1,
                        name: 'servicegroup',
                        title: 'Dept./ServiceGroup',
                        visible: true,
                        element: 'text',  
                    },
                    {
                        id: 1,
                        name: 'item_service',
                        title: 'Item / Service',
                        visible: true,
                        element: 'text',

                    },{
                        d: 1,
                        name: 'item_qty',
                        title: 'Item / Quantity',
                        visible: true,
                        element: 'text',  
                    },{
                        d: 1,
                        name: 'item_rate',
                        title: 'Item / Rate',
                        visible: true,
                        element: 'text',  
                    },{
                        d: 1,
                        name: 'item_amount',
                        title: 'Item / Amount',
                        visible: true,
                        element: 'text',  
                    },{
                        d: 1,
                        name: 'equservicecd',
                        title: 'EquServiceCode',
                        visible: true,
                        element: 'text',  
                    },
                    {
                        d: 1,
                        name: 'isactive',
                        title: 'IsActive',
                        visible: true,
                        element: 'text',  
                    },
                    {
                        d: 1,
                        name: 'ward_name',
                        title: 'Ward Name',
                        visible: true,
                        element: 'text',  
                    },
                    {
                        d: 1,
                        name: 'level1_desc',
                        title: 'Level1 Desc',
                        visible: true,
                        element: 'text',  
                    }]
                }
            }]
        }

const excludesSchema = {
            feilds: [{
                id: 1,
                name: 'exlcudes',
                title: 'Excludes',
                visible: true,
                Specification: {
                    'type': 'table',
                    // 'add_more': true,
                    // 'add_more_title': 'Add Excludes',
                    'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" },{'id': 2, 'text': 'Package Name', width: "30%" }, { 'id': 3, 'text': 'Serivce Type', width: "15%" }, { 'id': 4, 'text': 'Dept./ServiceGroup', width: "25%" }, { 'id': 5, 'text': 'Service Name', width: "25%" }, { 'id': 6, 'text': 'Quantity', width: "18%" }, { 'id': 7, 'text': 'Rate (Rs.)', width: "18%" }, { 'id': 8, 'text': 'Amount (Rs.)', width: "18%" }, { 'id': 9, 'text': 'EquServiceCode', width: "18%" }, { 'id': 10, 'text': 'IsActive', width: "18%" },{ 'id': 11, 'text': 'Ward Name', width: "45%" },{ 'id': 12, 'text': 'Level1 Desc Name', width: "45%" }],
                    'table_body': [
                        // {
                        //     'id': 1,
                        //     'text': 'item_service',
                        //     'type': 'Item / Service',
                        //     'input_feild': [],
                        //     'feilds': [{

                        //         id: 1,
                        //         name: 'excludes_service_id',
                        //         title: '',
                        //         visible: true,
                        //         icon: 'number',
                        //         element: 'select',
                        //         required: true,
                        //         type: 'select',
                        //         placeholder: 'Select Service',
                        //         rules: [],
                        //         errors: [],
                        //         value: null,
                        //         valid: false,
                        //         state: '',
                        //         disable: false,
                        //         className: 'w-100',
                        //         row_group: 'Routine',
                        //         column_group: 'qty',
                        //     }, {
                        //         id: 1,
                        //         name: 'qty',
                        //         title: '',
                        //         visible: true,
                        //         icon: 'number',
                        //         element: 'input',
                        //         required: true,
                        //         type: 'number',
                        //         placeholder: 'Item / Service Quantity',
                        //         rules: [],
                        //         errors: [],
                        //         value: null,
                        //         valid: false,
                        //         state: '',
                        //         disable: true,
                        //         className: 'w-100',
                        //         row_group: 'Routine',
                        //         column_group: 'qty',
                        //     }, {
                        //         id: 1,
                        //         name: 'rate',
                        //         title: 'Item / Service Rate',
                        //         visible: true,
                        //         icon: 'number',
                        //         element: 'input',
                        //         required: true,
                        //         type: 'number',
                        //         placeholder: 'Item / Service Rate',
                        //         rules: [],
                        //         errors: [],
                        //         value: null,
                        //         valid: false,
                        //         state: '',
                        //         disable: true,
                        //         className: 'col-3',
                        //         row_group: 'Routine',
                        //         column_group: 'rate',
                        //     }, {
                        //         id: 1,
                        //         name: 'amount',
                        //         title: 'Item / Service Amount',
                        //         visible: true,
                        //         icon: 'number',
                        //         element: 'input',
                        //         required: true,
                        //         type: 'number',
                        //         placeholder: 'Item / Service Amount',
                        //         rules: [],
                        //         errors: [],
                        //         value: null,
                        //         valid: false,
                        //         state: '',
                        //         disable: true,
                        //         className: 'col-3',
                        //         row_group: 'Routine',
                        //         column_group: 'amount',
                        //     }, {
                        //         id: 1,
                        //         name: 'action',
                        //         title: '--',
                        //         visible: true,
                        //         element: 'text',

                        //     },]
                        // }
                    ],
                    // 'add_more_feilds': [{

                    //     id: 1,
                    //     name: 'excludes_service_id',
                    //     title: '',
                    //     visible: true,
                    //     icon: 'number',
                    //     element: 'select',
                    //     required: true,
                    //     type: 'select',
                    //     placeholder: 'Select Service',
                    //     rules: [],
                    //     errors: [],
                    //     value: null,
                    //     valid: false,
                    //     state: '',
                    //     disable: false,
                    //     className: 'w-100',
                    //     row_group: 'Routine',
                    //     column_group: 'qty',
                    // }, {
                    //     id: 1,
                    //     name: 'qty',
                    //     title: 'Item / Service Qty.',
                    //     visible: true,
                    //     icon: 'number',
                    //     element: 'input',
                    //     required: true,
                    //     type: 'number',
                    //     placeholder: 'Item / Service Quantity',
                    //     rules: [],
                    //     errors: [],
                    //     value: null,
                    //     valid: false,
                    //     state: '',
                    //     disable: true,
                    //     className: 'col-3',
                    //     row_group: 'Highend',
                    //     column_group: 'qty',
                    // }, {
                    //     id: 1,
                    //     name: 'rate',
                    //     title: 'Item / Service Rate',
                    //     visible: true,
                    //     icon: 'number',
                    //     element: 'input',
                    //     required: true,
                    //     type: 'number',
                    //     placeholder: 'Item / Service Rate',
                    //     rules: [],
                    //     errors: [],
                    //     value: null,
                    //     valid: false,
                    //     state: '',
                    //     disable: true,
                    //     className: 'col-3',
                    //     row_group: 'Highend',
                    //     column_group: 'rate',
                    // }, {
                    //     id: 1,
                    //     name: 'amount',
                    //     title: 'Item / Service Amount',
                    //     visible: true,
                    //     icon: 'number',
                    //     element: 'input',
                    //     required: true,
                    //     type: 'number',
                    //     placeholder: 'Item / Service Amount',
                    //     rules: [],
                    //     errors: [],
                    //     value: null,
                    //     valid: false,
                    //     state: '',
                    //     disable: true,
                    //     className: 'col-3',
                    //     row_group: 'Highend',
                    //     column_group: 'amount',
                    // }, {
                    //     id: 1,
                    //     name: 'action',
                    //     title: '--',
                    //     visible: true,
                    //     element: 'action',
                    // }],
                    'add_more_feilds': [
                    {
                        d: 1,
                        name: 'item_package',
                        title: 'Item / package',
                        visible: true,
                        element: 'text', 
                    },
                    {
                        d: 1,
                        name: 'servicetype',
                        title: 'Service Type',
                        visible: true,
                        element: 'text',  
                    },
                    {
                        d: 1,
                        name: 'servicegroup',
                        title: 'Dept./ServiceGroup',
                        visible: true,
                        element: 'text',  
                    },
                    {
                        id: 1,
                        name: 'excludes_service_id',
                        title: 'Item / Service',
                        visible: true,
                        element: 'text',
        
                    },
                    // {
                    //     d: 1,
                    //     name: 'item_package',
                    //     title: 'Item / package',
                    //     visible: true,
                    //     element: 'text', 
                    // },
                    {
                        d: 1,
                        name: 'qty',
                        title: 'Item / Quantity',
                        visible: true,
                        element: 'text',  
                    },
                    {
                        d: 1,
                        name: 'rate',
                        title: 'Item / Rate',
                        visible: true,
                        element: 'text',  
                    },
                    {
                        d: 1,
                        name: 'amount',
                        title: 'Item / Amount',
                        visible: true,
                        element: 'text',  
                    },
                    {
                        d: 1,
                        name: 'equservicecd',
                        title: 'EquServiceCode',
                        visible: true,
                        element: 'text',  
                    },
                    {
                        d: 1,
                        name: 'isactive',
                        title: 'IsActive',
                        visible: true,
                        element: 'text',  
                    },
                    {
                        d: 1,
                        name: 'ward_name',
                        title: 'Ward Name',
                        visible: true,
                        element: 'text',  
                    },
                    {
                        d: 1,
                        name: 'level1_desc',
                        title: 'Level1 Desc',
                        visible: true,
                        element: 'text',  
                    }]
                }
            }]
        }

const excludesAddMoreSchema = {
            // feilds: [{
            //     name: 'pre_existing_group',
            //     data: [{
            //         id: 1,
            //         name: 'choose',
            //         title: 'Enter Excludes',
            //         visible: true,
            //         icon: 'number',
            //         element: 'input',
            //         required: true,
            //         type: 'text',
            //         placeholder: 'Enter Excludes',
            //         rules: [],
            //         errors: [],
            //         value: null,
            //         valid: false,
            //         state: '',
            //         disable: false,
            //         className: 'col-3',
            //         row_group: 'Highend',
            //         column_group: 'choose',
            //     }, {
            //         id: 1,
            //         name: 'qty',
            //         title: 'Qty.',
            //         visible: true,
            //         icon: 'number',
            //         element: 'input',
            //         required: true,
            //         type: 'number',
            //         placeholder: 'Qty',
            //         rules: [],
            //         errors: [],
            //         value: null,
            //         valid: false,
            //         state: '',
            //         disable: false,
            //         className: 'col-3',
            //         row_group: 'Highend',
            //         column_group: 'qty',
            //     }, {
            //         id: 1,
            //         name: 'rate',
            //         title: 'Rate',
            //         visible: true,
            //         icon: 'number',
            //         element: 'input',
            //         required: true,
            //         type: 'number',
            //         placeholder: 'Rate',
            //         rules: [],
            //         errors: [],
            //         value: null,
            //         valid: false,
            //         state: '',
            //         disable: false,
            //         className: 'col-3',
            //         row_group: 'Highend',
            //         column_group: 'rate',
            //     }, {
            //         id: 1,
            //         name: 'amount',
            //         title: 'Amount',
            //         visible: true,
            //         icon: 'number',
            //         element: 'input',
            //         required: true,
            //         type: 'number',
            //         placeholder: 'Amount',
            //         rules: [],
            //         errors: [],
            //         value: null,
            //         valid: false,
            //         state: '',
            //         disable: false,
            //         className: 'col-3',
            //         row_group: 'Highend',
            //         column_group: 'amount',
            //     }]
            // }]
        }

const changepaymentSchema = Object.seal({
            feilds: [{
                id: 1,
                name: 'payment_reason',
                title: 'Reason *',
                visible: true,
                element: 'input',
                required: false,
                type: 'text',
                placeholder: 'Enter',
                icon: 'user',
                rules: [{
                    test: (value) => {
                        return (value !== null && value.length > 0 && value != '');
                    },
                    message: 'Please Enter Reason'
                }],
                errors: [],
                value: null,
                valid: false,
                disable: false,
                className: 'col-3'
            }]
        })

const signatureSchema = {
    feilds: [
        {
            id: 1,
            name: 'phonenumber',
            title: 'Whatsapp Number *',
            visible: true,
            element: 'input',
            required: false,
            type: 'text',
            placeholder: 'Enter',
            icon: 'user',
            rules: [{
                test: (value) => {
                    return (value !== null && value.length > 0 && value != '');
                },
                message: 'Please Enter Whatsapp Number'
            }],
            errors: [],
            value: null,
            valid: false,
            disable: false,
            className: 'col-3'
        },
        {
            id: 2,
            name: 'signature',
            title: 'Sign here and submit the signature *',
            visible: true,
            element: 'signature_pad',
            required: false,
            type: 'file',
            placeholder: 'Enter',
            icon: 'user',
            rules: [{
                test: (value) => {
                    return (value && value.length > 0);
                },
                message: 'Please Sign Here..'
            }],
            errors: [],
            value: null,
            valid: false,
            disable: false,
            className: 'col-3'
        },
    ]
}

export { basicDetailsSchema, changepaymentSchema, medicationDetailsSchema, estimateBreakupFormatSchema, addonSchema, roomtypeSchema, includesSchema, excludesSchema, excludesAddMoreSchema, additionalPackageSchema, additionalProcedureSchema, signatureSchema, };